import en from './en.yml';
import de from './de.yml';
import { Translations } from '../types/translations';

const translations: Translations = {
  // @ts-ignore
  en: en,
  // @ts-ignore
  de: de,
};
// @ts-ignore-end

export default translations;
